<template>
  <div>
    <ul class="u-center pagination text-md font-medium">
      <!-- left arrow -->
      <OLink v-if="pagination.currentPage > 1" :href="getPageLink(pagination.currentPage - 1)" variant="pure">
        <li class="u-center mr-2 w-10 h-10 leading-32 text-primary-100 bg-white hover:bg-[#E2E5ED] border border-[#E2E5ED] rounded-lg">
          <OIcon icon="left" />
        </li>
      </OLink>

      <!-- first page -->
      <OLink v-if="pagination.currentPage > 0" :href="getPageLink(1)">
        <li
          class="page_item mr-2 min-w-10 h-10 px-1 u-center leading-32 bg-white border border-[#E2E5ED] rounded-lg"
          :class="{
            'font-bold bg-[#8197AF] text-white border-0': pagination.currentPage === 1,
            'hover:bg-[#E2E5ED] text-primary-300': pagination.currentPage !== 1,
          }"
        >
          1
        </li>
      </OLink>

      <!-- dots -->
      <li v-if="pagination.currentPage > 2" class="h-10 min-w-10 mr-2 u-center leading-32 text-primary-300">...</li>

      <!-- active page -->
      <li
        v-if="pagination.currentPage > 1"
        class="page_item mr-2 min-w-10 h-10 px-1 u-center leading-32 bg-[#8197AF] text-white font-bold rounded-lg"
      >
        {{ pagination.currentPage }}
      </li>

      <!-- right arrow -->
      <OLink v-if="pagination.hasNextPage" :href="getPageLink(pagination.currentPage + 1)" variant="pure">
        <li class="u-center mr-0.5 w-10 h-10 leading-32 text-primary-100 bg-white hover:bg-[#E2E5ED] border border-[#E2E5ED] rounded-lg">
          <OIcon icon="right" />
        </li>
      </OLink>
    </ul>
  </div>
</template>

<script>
import { defineComponent, computed, useRouter, useRoute, onMounted } from '@nuxtjs/composition-api';
import { range } from 'lodash';
import { OLink, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OLink, OIcon },
  props: {
    /**
     * "slug" | "query"
     *
     * slug: sayfa numarasini suanki linkin sonuna page'i ekler
     * @example: /haberler => /haberler/2
     *
     * query: sayfa numarasini suanki linkin sonuna query param ekler
     * @example: /haberler => haberler?page=2
     */
    linkType: {
      type: String,
      default: 'slug',
      validator: (val) => ['slug', 'query'].includes(val),
    },
    hasNextPage: {
      type: Boolean,
    },
    currentPage: {
      type: [Number, String],
    },
  },
  setup(props) {
    const route = useRoute();
    const router = useRouter();

    const pagination = computed(() => ({
      currentPage: parseInt(props.currentPage),
      hasNextPage: props.hasNextPage,
    }));

    onMounted(() => {
      if (props.hasNextPage) {
        const link1 = document.createElement('link');
        link1.rel = 'next';
        link1.href = getPageLink(pagination.value.currentPage + 1);
        document.head.appendChild(link1);
      }
      if (pagination.value.currentPage > 1) {
        const link2 = document.createElement('link');
        link2.rel = 'prev';
        link2.href = getPageLink(pagination.value.currentPage - 1);
        document.head.appendChild(link2);
      }
    });

    const getPageLink = (page) => {
      page = String(page);
      const append = pagination.value.currentPage === 1;
      if (props.linkType === 'slug') return router.resolve({ path: parseInt(page) === 1 ? '.' : page, append }).href;
      if (props.linkType === 'query') return router.resolve({ query: { ...route.value.query, page } }).href;
    };

    return { pagination, range, getPageLink };
  },
});
</script>
